import { z, ZodType } from 'zod';

export const PERMISSIONS = {
	canCreateSubAccounts: 'canCreateSubAccounts',
	canWriteUsers: 'canWriteUsers',
	canEditLimits: 'canEditLimits',
	canEditGameSettings: 'canEditGameSettings',
	canWriteCashdesks: 'canWriteCashdesks',
	canBlockGames: 'canBlockGames',
} as const satisfies Record<string, string>;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export type Permissions = Record<Permission, boolean>;

export const permissionsSchema: ZodType<Permissions> = z.object({
	canCreateSubAccounts: z.boolean(),
	canWriteUsers: z.boolean(),
	canEditLimits: z.boolean(),
	canEditGameSettings: z.boolean(),
	canWriteCashdesks: z.boolean(),
	canBlockGames: z.boolean(),
});
